import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "main"
}

import { onMounted } from 'vue';
import { i18n } from '@/i18n';
import { storeToRefs } from 'pinia';
import OpeningVideo from '@/components/modal/OpeningVideo.vue';
import Home from '@/views/Home.vue';
import Error from '@/components/modal/Error.vue';
import Media from '@/components/modal/Media.vue';
import utils from '@/utils';
import { useHome, useOpening, useError } from '@/store';


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const { loadLocale } = i18n();
loadLocale(process.env.LOCALE || '');

const { error } = storeToRefs(useError());
const { isInit, entryVidId } = storeToRefs(useHome());
const { getHome } = useHome();
const { isPlaying } = storeToRefs(useOpening());
const { updateIsPlaying } = useOpening();
const checkIsFirstPlay = !window.localStorage.getItem('isFirstPlay');
onMounted(async () => {
  await getHome();
  if (!error.value) {
    const tag = document.createElement('script');
    tag.src = 'https://www.youtube.com/iframe_api';
    const firstScriptTag = document.getElementsByTagName('script')[0];
    if (firstScriptTag && firstScriptTag.parentNode) {
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }
    if (process.env.REGION === 'tw') {
      window.sitebar.create();
    }
    const accessToken =
      utils.getParam('gop_access_token') ||
      utils.getParam('access_token') ||
      localStorage.getItem('access_token');
    const isIngame =
      utils.getParam('partition') || localStorage.getItem('partition');
    if (
      !(accessToken && isIngame) &&
      (process.env.REGION === 'tw' || process.env.REGION === 'th')
    ) {
      try {
        window.sitefooter.create({
          game: 'aov',
          region: process.env.REGION,
        });
      } catch (err) {
        console.error(err);
      }
    }
    updateIsPlaying(checkIsFirstPlay);
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(isInit))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_Transition, { name: "fade" }, {
            default: _withCtx(() => [
              (_unref(isPlaying))
                ? (_openBlock(), _createBlock(OpeningVideo, {
                    key: 0,
                    youtube: _unref(entryVidId)
                  }, null, 8, ["youtube"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(Home),
          _createVNode(Media)
        ]))
      : _createCommentVNode("", true),
    _createVNode(Error)
  ], 64))
}
}

})